import React, { useState, useEffect } from 'react'
import Autocomplete from '@material-ui/lab/Autocomplete';
import HttpService from '../services/httpService';
import TextField from '@material-ui/core/TextField';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import Checkbox from '@material-ui/core/Checkbox';
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import { connect,useSelector } from "react-redux";
import { setLoading, setSnackInfo } from '../redux/actions/appAction';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import FormGroup from '@material-ui/core/FormGroup';
import PoSoMtrNewMaterialAddition from './PoSoMtrNewMaterialAddition';
import { Button } from '@material-ui/core';
import RadioGroup from '@material-ui/core/RadioGroup';
import Radio from '@material-ui/core/Radio';
import DeleteIcon from "@material-ui/icons/Delete";
import { Modal } from 'antd';
import RaiseAdhocPoSoModal from './raiseAdhocPoSoModal';
import AdhocHistoryModal from './adhocHistoryModal';
import { ROLENAME } from '../utils';
const useStyles = makeStyles((theme) => ({
  table: {
    minWidth: 850,
  },
  formControl: {
    margin: theme.spacing(3),
  },
  root: {
    display: 'flex',
  },
  container: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  textField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    width: 200,
  },
}));

const StyledTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: "#ccc",
    color: theme.palette.common.black,
  },
  body: {
    fontSize: 14,
  },
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
  root: {
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.action.hover,
    },
  },
}))(TableRow);

const RaiseSoModal = (props) => {
  const classes = useStyles();
  const [showAdhocModal, setShowAdhocModal] = useState(false);
	const [showAdhocHistoryModal, setShowAdhocHistoryModal] = useState(false);
  const { userDetails } = useSelector(state => state.user);
	const canRaiseAdhoc = userDetails?.roles?.some(role => [ROLENAME.ExecutionUser, ROLENAME.Admin].includes(role.name));
	const canViewAdhocHistory = userDetails?.roles?.some(role => [ROLENAME.ExecutionUser, ROLENAME.Admin].includes(role.name));
  const [bomMaterials, setBomMaterials] = useState([])
  const [units, setUnits] = useState([])
  const [materialChosen, setMaterialChosen] = useState([])
  const [materialChosenDetails, setMaterialChosenDetails] = useState([])
  // const [vendors, setVendors] = useState([])
  const [selectedVendor, setSelectedVendor] = useState([])
  const [projectDetails, setProjectDetails] = useState([])
  const [projectCode, setProjectCode] = useState([])
  const [gstRequired, setGstRequired] = useState(false)
  const [soDetails, setSoDetails] = useState({
    deliveryDate: ""
  })
  const [submitting, setSubmitting] = useState(false)

  const [updateStdRateCheck,setUpdateStdRateCheck] = useState([]);
  const [oldProjectMap, setOldProjectMap] = React.useState({});
  const [oldProjectText, setOldProjectText] = React.useState({});

	// Function to handle checkbox checking for "updateStdRateCheck"
	const updateStdRateCheckHandler = (event,index)=>{
		let updateStdRate = [...updateStdRateCheck]
		updateStdRate[index] = event.target.checked
		setUpdateStdRateCheck(updateStdRate);
	}

  	// Initialize vendors and project codes from itemList if available
	useEffect(() => {
		const itemList = props.itemList || props.ITEMLIST || []
		if (itemList.length > 0 && materialChosenDetails.length > 0) {
			const vendors = []
			const projectCodes = []
			itemList.forEach((item, i) => {
				if (item?.vendor && materialChosenDetails[i]) {
					const vendorDetails = materialChosenDetails[i]?.vendorDetails || []
					const matchedVendor = vendorDetails.find(v => {
						const vendorId = v?.vendorId?._id || v?.vendorId
						const itemVendorId = item?.vendor?._id || item?.vendor
						return String(vendorId) === String(itemVendorId)
					})
					vendors[i] = matchedVendor || null
				}
				// Initialize project code from itemList
				if (item?.projectNumber) {
					const matchedProject = projectDetails.find(p => 
						String(p?.projectNumber) === String(item?.projectNumber)
					)
					projectCodes[i] = matchedProject || null
				}
			})
			if (vendors.length > 0) {
				setSelectedVendor(vendors)
			}
			if (projectCodes.length > 0) {
				setProjectCode(projectCodes)
			}
		}
		// eslint-disable-next-line 
	}, [props.itemList, props.ITEMLIST, materialChosenDetails, projectDetails])

  useEffect(() => {
    getUnits()
    getBomMaterials()
    getAllProjectHandle()
    // getVendors()
    // eslint-disable-next-line 
  }, [])

  const getAllProjectHandle = async () => {
    props.setLoading(true)
    try {
      const result = await HttpService.getAllProjectsBomMaterials()
      setProjectDetails(result.data)
    } catch (error) {
      console.error(error)
      props.setSnackInfo(error?.response?.data ?? "Something Went Wrong", "error")
    }
    props.setLoading(false)
  }

  useEffect(()=>{
    getAllProjectHandle()
  },[])

  const getBomMaterials = async () => {
    props.setLoading(true)
    try {
      const result = await HttpService.getBomOfProjectScope(props.SELECTEDPROJECT._id, props.SCOPE, props.TYPE)
      setBomMaterials(result.data)
    } catch (error) {
      console.error(error)
      props.setSnackInfo(error?.response?.data ?? "Something Went Wrong", "error")
    }
    props.setLoading(false)
  }

  const getUnits = async () => {
    try {
      const result = await HttpService.getAllUnits()
      setUnits(result.data)
    } catch (error) {
      console.error(error)
    }
  }

  // const getVendors = async () => {
  //   try {
  //     const result = await HttpService.getAllVendors()
  //     setVendors(result.data)
  //   } catch (error) {
  //     console.error(error)
  //   }
  // }

  const handleChange = (e) => {
    if (e.target.checked) {
      setMaterialChosen([...materialChosen, e.target.name])
      setMaterialChosenDetails([...materialChosenDetails, bomMaterials.filter(bom => {
        if (bom?.materialId?.name === e.target.name) {
					const availableQty = Number(
						((bom?.quantity || 0) - (bom?.raisedQty || 0)).toFixed(2)
					);

					setNewQuantity([
						...newQuantity,
						availableQty > 0 ? availableQty : ""
					]);
          // setNewQuantity([...newQuantity, Number(((bom?.quantity - bom?.raisedQty)).toFixed(2))])
          setSelectedUom([...selectedUom, bom?.materialId?.unitId ?? bom?.unitType])
          setProjectCode([...projectCode, null])
          return bom
        }
        return false
      })[0]])
    } else {
      setMaterialChosen(materialChosen.filter(material => material !== e.target.name))
      setMaterialChosenDetails(materialChosenDetails.filter((bom, i) => {
        if (bom?.materialId?.name !== e.target.name) {
          return bom
        } else {
          setSelectedVendor(selectedVendor.filter((q, idx) => i !== idx))
          setNewPrice(newPrice.filter((q, idx) => i !== idx))
          setSelectedUom(selectedUom.filter((q, idx) => i !== idx))
          setNewQuantity(newQuantity.filter((q, idx) => i !== idx))
          setProjectCode(projectCode.filter((q, idx) => i !== idx))
        }
        return false
      }
      ))

    }
  }
  const [newQuantity, setNewQuantity] = useState([])
  const [newPrice, setNewPrice] = useState([])

  const handleQuantity = (e, i, data) => {
    const value = e.target.value;

    // Only allow positive integers >= 1
    if (Number(value) < 1) {
      return props.setSnackInfo('Quantity must be greater than or equal to 1', "error");
    }

    const quant = [...newQuantity];
    quant[i] = value;
    setNewQuantity(quant);
  };

  const handlePrice = (e, i) => {
    let price = [...newPrice]
    price[i] = e.target.value
    setNewPrice(price)
  }

  const getSelectedVendor = (i) => {
    // First check if vendor is already selected in state
    if (selectedVendor[i]) {
      return selectedVendor[i]
    }
    
    // Check if there's an itemList prop with vendor information
    const itemList = props.itemList || props.ITEMLIST || []
    if (itemList[i]?.vendor) {
      const vendorFromItemList = itemList[i].vendor
      const materialData = materialChosenDetails[i]
      const vendorDetails = materialData?.vendorDetails || []
      
      // Find matching vendor from vendorDetails by ID
      const matchedVendor = vendorDetails.find(v => {
        const vendorId = v?.vendorId?._id || v?.vendorId
        const itemVendorId = vendorFromItemList?._id || vendorFromItemList
        return String(vendorId) === String(itemVendorId)
      })
      if (matchedVendor) {
        return matchedVendor
      }
    }
    
    // Check if materialChosenDetails has vendor information directly
    const materialData = materialChosenDetails[i]
    if (materialData?.vendor) {
      // Find matching vendor from vendorDetails by ID
      const vendorDetails = materialData?.vendorDetails || []
      const matchedVendor = vendorDetails.find(v => {
        const vendorId = v?.vendorId?._id || v?.vendorId
        const itemVendorId = materialData?.vendor?._id || materialData?.vendor
        return String(vendorId) === String(itemVendorId)
      })
      if (matchedVendor) {
        return matchedVendor
      }
    }
    
    return {}
  }

  const handleProjectCodeSelect = (e, v, i) => {
    let projectCodes = [...projectCode]
    projectCodes[i] = v
    setProjectCode(projectCodes)
  }

  const getSelectedProjectCode = (i) => {
    const item = projectCode[i]
    return item || null
  }

  const handleVendorSelect = (e, v, i) => {
    setSelectedVendor([])
		let missing_docs = ''
		if(!v.vendorId.aadharCardLink || (v.vendorId.aadharCardLink.length < 1))
		{
			missing_docs += 'Aadhar Card,'
			
		}
		if(!v.vendorId.panCardLink || (v.vendorId.panCardLink.length < 1))
		{
			missing_docs += 'PAN Card,'
			
		}
		if(missing_docs.length > 0)
		{
			props.setSnackInfo(`${v.vendorId.name} did not provided ${missing_docs} can't raise PO/SO for them.`, 'error')
			return
		}
    
    if (v) {
      let vendor = [...selectedVendor]
      vendor[i] = v
      setSelectedVendor(vendor)
      let price = [...newPrice]
      price[i] = v?.pricePerUnit
      setNewPrice(price)
    }
  }

  const [selectedUom, setSelectedUom] = useState([])

  const handleUomSelect = (e, v, i) => {
    let uom = [...selectedUom]
    uom[i] = v
    setSelectedUom(uom)
  }

  const getSelectedUom = (i) => {
    const item = selectedUom[i]
    return item || {}
  }

  const createSO = async () => {
    if (submitting) return
    setSubmitting(true)
    props.setLoading(true)
    try {
      const obj = materialChosenDetails.map((material, i) => {
        // If checkbox is checked, use manually typed projectNumber from oldProjectText
        // Otherwise, use selected project from dropdown
        const projectNumberValue = oldProjectMap[i] 
          ? (oldProjectText[i] || "") 
          : (projectCode[i]?.projectNumber || projectCode[i] || "");
        return {
          vendorId: selectedVendor[i],
          materialId: material.materialId,
          projectMaterialId: material?._id,
          newPrice: newPrice[i],
          quantity: material.quantity,
          raisedQty: material.raisedQty,
          newQuantity: newQuantity[i],
          unitId: selectedUom[i],
          updateStdRate:updateStdRateCheck[i] !== undefined ? updateStdRateCheck[i] : false,
          vendorRate: selectedVendor[i].pricePerUnit,
          projectNumber: projectNumberValue,

        }
      })

      // VALIDATION: If any projectNumber is empty AND condition satisfied → throw error
      const isServiceClient =
      !(props.PROJECTINFO.leadDetails && typeof props.PROJECTINFO.leadDetails === "object") &&
      props.PROJECTINFO.clientName?.toLowerCase().includes("service");
  
      const hasEmptyProjectNumber = obj.some(item => !item.projectNumber);
  
      if (hasEmptyProjectNumber && isServiceClient) {
        throw new Error("Something went wrong: Missing project number");
      }

      const SO = {}
      SO.projectId = props.SELECTEDPROJECT._id
      SO.deliveryDate = soDetails?.deliveryDate
      SO.gstRequired = gstRequired
      SO.materials = obj
      if (gstRequired) {
        SO.gstDetails = gstDetails;
      }
      const result = await HttpService.createServiceOrderFromBomMaterials(SO, props.SCOPE)
      if (result.status === 201) {
        props.CLOSEMODAL()
        props.setSnackInfo('SO CREATED', "success")
      }
    } catch (error) {
      console.error(error)
      props.setSnackInfo(error?.response?.data ?? "Something Went Wrong", "error")
    }
    props.setLoading(false)
    setSubmitting(false)
  }

	const [showNewMaterialModal,setShowNewMaterialModal] = useState(false);
  const addMoreMaterialHandler = (data)=>{
		let newArr  = [...materialChosenDetails,...data];
		setMaterialChosenDetails(newArr);
    // Initialize projectCode for new materials
		const newProjectCodes = [...projectCode, ...data.map(() => null)];
		setProjectCode(newProjectCodes);
	}

  const [gstDetails, setGstDetails] = useState({
		gst: "",
		rate: ""
	})

  const gstPercent = [
		"5", "12", "18", "28"
	]

  const handleGstType = (e) => {
		setGstDetails({ ...gstDetails, gst: e.target.value })
	}

  // Function to remove a material from the list of chosen materials for a Purchase Order (PO)
  const handleRemoveAddedMaterialForSO = (index) => {
    try {
        // Create a new array excluding the material at the specified index
        const updatedMaterialList = materialChosenDetails.filter((_, i) => i !== index);

        // Update the state with the filtered array
        setMaterialChosenDetails(updatedMaterialList);
    } catch (error) {
        // Log any errors that occur during the operation
        console.error("Error while removing material -> ", error);
    }
  };

  const handleOldProjectCheck = (index) => (event) => {
    setOldProjectMap((prev) => ({
      ...prev,
      [index]: event.target.checked,
    }));
  };
  
  const handleOldProjectTextChange = (index) => (event) => {
    setOldProjectText((prev) => ({
      ...prev,
      [index]: event.target.value,
    }));
  };

  return (
    <div>
        {canRaiseAdhoc && <Button variant="contained" color="primary" style={{ background: "#F47E46", color: "#FFF2EB", margin: 5 }} onClick={() => setShowAdhocModal(true)}>Add Ad-hoc PO/SO</Button>}
        {canViewAdhocHistory && <Button variant="outlined" style={{ margin: 5 }} onClick={() => setShowAdhocHistoryModal(true)}>Ad-hoc History</Button>}
      <Modal
        title="Add Ad-hoc PO/SO"
        centered
        visible={showAdhocModal}
        onCancel={() => setShowAdhocModal(false)}
        width={1100}
        maskClosable={false}
        footer={null}
        destroyOnClose
      >
        <RaiseAdhocPoSoModal SELECTEDPROJECT={props.SELECTEDPROJECT} PROJECTINFO={props.PROJECTINFO} SCOPE={props.SCOPE} CLOSEMODAL={() => setShowAdhocModal(false)} />
      </Modal>
      <Modal
        title="Ad-hoc PO/SO History"
        centered
        visible={showAdhocHistoryModal}
        onCancel={() => setShowAdhocHistoryModal(false)}
        width={1200}
        footer={null}
        destroyOnClose
      >
        <AdhocHistoryModal SELECTEDPROJECT={props.SELECTEDPROJECT} />
      </Modal>
      {bomMaterials.length > 0 ? <div>
        <div className="procurement-header">Create Service Order</div>
        <div>
          <TableContainer component={Paper}>
            <Table className={classes.table} size="small" aria-label="customized table">
              <TableHead>
                <TableRow>
                  <StyledTableCell>Sl No</StyledTableCell>
                  <StyledTableCell>Material Name</StyledTableCell>
                  <StyledTableCell>Uom</StyledTableCell>
                  <StyledTableCell>Quantity</StyledTableCell>
                  <StyledTableCell>Raised Qty</StyledTableCell>
                  <StyledTableCell>Received Qty</StyledTableCell>
                  <StyledTableCell>Action</StyledTableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {bomMaterials.map((data, i) => <StyledTableRow StyledTableRow key={i + 1}>
                  <StyledTableCell>{i + 1}</StyledTableCell>
                  <StyledTableCell>{data?.materialId?.name}</StyledTableCell>
                  <StyledTableCell>{data?.materialId?.unitId?.name}</StyledTableCell>
                  <StyledTableCell>{data?.quantity}</StyledTableCell>
                  <StyledTableCell>{data?.raisedQty}</StyledTableCell>
                  <StyledTableCell>{data?.receivedQty}</StyledTableCell>
                  <StyledTableCell><FormControl component="fieldset" className={classes.formControl}>
                    <FormGroup>
                      <FormControlLabel
                        control={<Checkbox checked={materialChosen.includes(data?.materialId?.name)} onChange={handleChange} name={data?.materialId?.name} />}
                      />
                    </FormGroup>
                  </FormControl></StyledTableCell>
                </StyledTableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </div>
        <div className='modal-header' style={{ justifyContent: "space-between", paddingTop: 10 }}>
          <div style={{ width: "40%" }}>
            <b>Project: </b>
            <span>{`${props.PROJECTINFO.projectCode}_${props.PROJECTINFO.clientName}`}</span>
          </div>
          <div style={{ width: "40%" }}>
            <TextField
              id="date"
              name="deliveryDate"
              onChange={(e) => setSoDetails({ ...soDetails, [e.target.name]: e.target.value })}
              label="Expected Delivery Date"
              type="date"
              className={classes.textField}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </div>
        </div>
        {!showNewMaterialModal &&  <Button variant="contained" color="primary" style={{ background: "#716ACA", margin: 5 }} onClick={()=> {setShowNewMaterialModal(true);} }>Add New Material</Button>}
				{showNewMaterialModal && <PoSoMtrNewMaterialAddition MOUNTED={true} SCOPE={props.SCOPE} addMoreMaterialHandler={addMoreMaterialHandler} setShowNewMaterialModal={setShowNewMaterialModal} bomMaterials={bomMaterials} TYPE={props.TYPE}/>}
        {materialChosenDetails.length > 0 && <div>
          <TableContainer component={Paper}>
            <Table className={classes.table} size="small" aria-label="customized table">
              <TableHead>
                <TableRow>
                  <StyledTableCell>Sl No</StyledTableCell>
                  <StyledTableCell>Name/Code</StyledTableCell>
                  <StyledTableCell>Quantity</StyledTableCell>
                  <StyledTableCell>New Quantity</StyledTableCell>
                  <StyledTableCell>Unit</StyledTableCell>
                  <StyledTableCell>Pick Vendor</StyledTableCell>
                  {(!(props.PROJECTINFO.leadDetails
                  && typeof props.PROJECTINFO.leadDetails
                  === "object") && (props.PROJECTINFO.clientName && props.PROJECTINFO.clientName.toLowerCase().includes("service")) ) && 
                    <StyledTableCell>Choose Project</StyledTableCell>}
                  <StyledTableCell>Price</StyledTableCell>
                  <StyledTableCell>Update Std. Rate</StyledTableCell>
                  {/* <StyledTableCell>New Price</StyledTableCell> */}
                </TableRow>
              </TableHead>
              <TableBody>
                {materialChosenDetails.map((data, i) => <StyledTableRow StyledTableRow key={i + 1}>
                  <StyledTableCell>{i + 1}</StyledTableCell>
                  <StyledTableCell>{data?.materialId?.name}</StyledTableCell>
                  <StyledTableCell>{data?.quantity}</StyledTableCell>
                  <StyledTableCell>
                    <TextField
                      id="newQty"
                      className={classes.textField}
                      type="number"
                      name="newQuantity"
                      value={newQuantity[i]}
                      onChange={(e) => handleQuantity(e, i, data)}
                      variant="outlined"
                      inputProps={{ min: 1 }}
                      onKeyDown={(e) => {
                        if (["-", "+", "e", "E"].includes(e.key)) {
                          e.preventDefault();
                        }
                      }}
                    />
                  </StyledTableCell>	
                  <StyledTableCell><Autocomplete
                    value={getSelectedUom(i)}
                    onChange={(e, v) => handleUomSelect(e, v, i)}
                    id="Unit"
                    options={units}
                    getOptionLabel={(option) => option.name}
                    style={{ width: 150 }}
                    renderInput={(params) => <TextField {...params} fullWidth variant="outlined" />}
                  /></StyledTableCell>
                  <StyledTableCell>
                    < Autocomplete
                      value={getSelectedVendor(i)}
                      onChange={(e, v) => handleVendorSelect(e, v, i)}
                      id="Vendor"
                      options={data?.vendorDetails}
                      getOptionLabel={(option) => option?.vendorId?.name}
                      style={{ width: 250 }}
                      renderInput={(params) => <TextField {...params} fullWidth variant="outlined" />}
                    />
                  </StyledTableCell>

                  {(!(props.PROJECTINFO.leadDetails
                  && typeof props.PROJECTINFO.leadDetails
                  === "object") && (props.PROJECTINFO.clientName && props.PROJECTINFO.clientName.toLowerCase().includes("service")) ) && 
                    <StyledTableCell>
                      {/* Checkbox */}
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={!!oldProjectMap[i]}
                            onChange={handleOldProjectCheck(i)}
                            color="primary"
                          />
                        }
                        label="Is old project?"
                      />

                      {/* Text Field – only if checked */}
                      {oldProjectMap[i] && (
                        <TextField
                          value={oldProjectText[i] || ""}
                          onChange={handleOldProjectTextChange(i)}
                          label="Old Project Code"
                          variant="outlined"
                          size="small"
                          fullWidth
                          style={{ marginTop: 8, width: 250 }}
                        />
                      )}
                      {!oldProjectMap[i] && <Autocomplete
                        value={getSelectedProjectCode(i)}
                        onChange={(event, value) => handleProjectCodeSelect(event, value, i)}
                        id={`project-code-dropdown-${i}`}
                        options={projectDetails}
                        getOptionLabel={(option) => option?.projectNumber || ""}
                        style={{ width: 250 }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label="Project Code"
                            fullWidth
                            variant="outlined"
                          />
                        )}
                      />}
                    </StyledTableCell>}

                  {/* <StyledTableCell>{'selectedVendor[i]?.pricePerUnit'}</StyledTableCell> */}
                  <StyledTableCell><TextField className={classes.textField} id="newPrice" value={newPrice[i]} onChange={(e) => handlePrice(e, i)} type="number" variant="outlined" /></StyledTableCell>
                  <StyledTableCell>
                    { +selectedVendor[i]?.pricePerUnit < +newPrice[i] && 
                      <FormControlLabel onChange={(event)=>updateStdRateCheckHandler(event,i)} control={<Checkbox checked={updateStdRateCheck[i]}/>} label="" />
                    }
                  </StyledTableCell>
                  <StyledTableCell>
                    <DeleteIcon
                      style={{ cursor: "pointer", verticalAlign: 'middle', marginLeft: 10, color: "red", fontSize: 20 }}
                      onClick={() => handleRemoveAddedMaterialForSO(i)}
                    />
                  </StyledTableCell>
                </StyledTableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
          {props.TYPE === "SO" && <div>
            <div className='gst-header'>Add GST and extra charge details</div>
            <div className='gst-checked-options'>
              <span className='procurement-discount' style={{ border: '1.5px solid #ccc', padding: '5.5px 0px', borderRadius: '3.5px' }}><Checkbox
                checked={gstRequired}
                onChange={(e) => setGstRequired(e.target.checked)}
                inputProps={{ 'aria-label': 'primary checkbox' }}
              />GST Required</span>
            </div>
            {gstRequired && <div className='gst-radio-percent'>
              <FormControl component="fieldset" className={classes.root}
                style={{ border: '1.5px solid #ccc', padding: '5.5px 0px', borderRadius: '3.5px', width: '48%' }}>
                <RadioGroup aria-label="type" name="type" value={gstDetails?.gst} onChange={handleGstType}>
                  <div className='gst-type-radio'>
                    <FormControlLabel value="SGST" control={<Radio />} label="CGST/SGST" />
                    <FormControlLabel value="IGST" control={<Radio />} label="IGST" />
                  </div>
                </RadioGroup>
              </FormControl>
              <Autocomplete
                value={gstDetails?.rate}
                onChange={(e, value) => setGstDetails({ ...gstDetails, rate: value })}
                id="percent"
                options={gstPercent}
                getOptionLabel={(option) => `${option}%`}
                style={{ width: '48%' }}
                renderInput={(params) => <TextField {...params} label={`Select ${gstDetails?.gst} percent`} fullWidth variant="outlined" />}
              /></div>}
          </div>}
          <button onClick={createSO} disabled={submitting} className='procurement-create-btn'>{submitting ? 'Creating...' : 'Create'}</button>
        </div>}
      </div > : <div>Please Upload a BOM Material for this Scope</div>
      }
    </div >
  )
}

export default connect(null, { setLoading, setSnackInfo })(RaiseSoModal)
